<script>
    import { estimate_service, estimate_service_mob } from "./header_data.js";
    import Header from "./header-section.svelte";
    import Gallary from "./gallary.svelte";
    import { estimate_gallery } from "./gallary.js";
    import { title, show } from "./store.js";
    import PopUpButton from "./popUp_button.svelte";
    import YourPlan from "./submit_your_plan.svelte";
    import Footer from "./footer.svelte";
    import MobileView from "./estimation_mbl.svelte";
    import MobileButton from "./popUp_button_mob.svelte";
    title.set("Estimation");
    $: console.log("gallary", estimate_gallery);
    let bullet = [
        {
            step: "Step 1",
            point: "You send us project details and we translate them into digital quantities using our state-of-the-art software system.",
        },
        {
            step: "Step 2",
            point: "After the data is assembled, the takeoff quantities will be transferred and organized into specific outlines on excel spreadsheets.",
        },
        {
            step: "Step 3",
            point: "Once we calculate the price of labor and material costs by conducting an analysis of wages and pricing, we will suggest the best price that you can finalize.",
        },
        {
            step: "Step 4",
            point: "To complete the process, our lead estimator will conduct a final check to review the quality of the project deliverables to maintain quality control.",
        },
    ];
    let text = [
        {
            heading: "You Send Us Your Plans to Review",
            info: " You can send them to ,<a style='color:#3C88C3; font-weight: bold; ' href='mailto:hello@automason.ai'>hello@automason.ai</a> or if they are large files, upload through our Dropbox.",
        },
        {
            heading: "We Estimate and Send you Your Project",
            info: " Our team will digitally takeoff the quantities for your project and prepare your <br> entire bid for you. We use a highly accurate cost database that’s based on the <br> zip code so the numbers will be extremely accurate and competitive.",
        },
        {
            heading: "We Send you a Quote for the Project",
            info: " Before starting, we’ll send you a detailed quote for our services. We look at <br> things like size, difficulty, complexity, and bid date when determining pricing.<br> Every project is unique so we take the time to review each project individually.",
        },
    ];

    function displayPopUp() {
        show.update((n) => n + 1);
        console.log("show", show);
    }
</script>

<Header
    data_desktop={estimate_service}
    data_mobile={estimate_service_mob}
    top={"100vw"}
    line_stroke={"white"}
    logo_color={"white"}
    logo_stroke={"white"}
    Width_line="36vw"
>
    <div slot="btn">
        <div class="desktop" style="margin-top: 0.5vw; margin-left:7.135vw;">
            <PopUpButton
                border_radius="0.625vw"
                padding="1.042vw 3.073vw"
                title="Contact"
                me="2"
                btnStyle="nav_bar_btn"
                px="0"
                on:click={() => {
                    displayPopUp();
                }}
            />
        </div>
        <div class="mobile">
            <MobileButton
                title={"Contact"}
                on:click={() => {
                    displayPopUp();
                }}
            />
        </div>
    </div>
</Header>
<YourPlan />
<div class="desktop">
    <div
        style="
        line-height: 2.344vw;
        text-align: center;
        margin-top: 5.26vw;
        color: rgba(0, 0, 0, 1);"
    >
        <p
            style="    font-size: 1.563vw;
        font-weight: 400;"
        >
            We use proven strategies to help you churn the numbers into the BEST
            deals possible <br /> by giving you real time support and foolproof advice
            on how to negotiate.
        </p>
        <p
            style="    font-size: 1.563vw;
        font-weight: 400;"
        >
            What we’re providing is an easy estimation process that lands you
            the bids that you <br /> want without the hassle of it all. By
            cutting your time in half, and using solid methods to <br /> close, you’ll
            make all your projects successful, all within a few clicks!
        </p>
    </div>
    <div>
        <div
            style="    width: 11.927vw;
        margin: auto;
        margin-top: 6.563vw;"
        >
            <img src="images/drafting/dots_lines.svg" alt="" width="100%" />
        </div>
        <div
            style="    width: 20vw;
        margin-top: -4.3vw;
        margin-left: 44.5vw;"
        >
            <h1 style="font-size: 2.083vw; text-transform: uppercase;">
                Our Services
            </h1>
        </div>
    </div>
    <div style="margin-top: 4.948vw; margin-bottom:7vw;">
        <Gallary coming_data={estimate_gallery} width="90vw" />
    </div>
    <div>
        <div style="width: 41.927vw;margin-top: 6.563vw;margin-left: 6.510vw;">
            <img src="images/drafting/dots_lines1.svg" alt="" width="100%" />
        </div>
        <div style="margin-top: -3.8vw; margin-left: 7.5vw;">
            <h1 style="font-size: 2.083vw; text-transform: uppercase;">
                The Estimation Procedure We Follow:
            </h1>
        </div>
    </div>
    <div style="display: flex;margin-left: 7vw;margin-top: 3vw;">
        <div>
            <ul style="list-style-type: square;width: 31vw;">
                {#each bullet as data}
                    <li>
                        <p style="font-weight: 600;font-size:1.042vw;">
                            {data.step}
                        </p>
                        <p style="font-size:1.042vw;">
                            {data.point}
                        </p>
                    </li>
                {/each}
            </ul>
        </div>
        <div style="width: 42.865vw;margin-top: 4vw;margin-left: 8vw;">
            <img
                src="images/estimate_gallery/kaleidico_3V.png"
                alt=""
                width="100%"
            />
        </div>
    </div>
    <div
        style="    font-weight: 500;
    color: rgb(243, 101, 50);
    margin-left: 6vw;
    margin-top: 2vw;"
    >
        <div
            class="submit-a-quote"
            on:click={() => {
                displayPopUp();
            }}
        >
            <h5 style="font-weight:500; color:#F36532; margin: 0;">
                Get a Quote
            </h5>
            <div class="submit-a-quote-arrow">
                <img src="/images/estimate_gallery/arrow.svg" alt="" />
            </div>
        </div>
    </div>
    <div>
        <div style="width: 41.927vw;margin-top: 6.563vw;margin-left: 15.885vw;">
            <img src="images/drafting/dots_lines1.svg" alt="" width="100%" />
        </div>
        <div style="margin-top: -3.8vw; margin-left: 17.146vw;">
            <h1 style="font-size: 2.083vw; text-transform: uppercase;">
                Benefits of choosing Automason:
            </h1>
        </div>
    </div>
    <div style="position:relative;">
        <div
            style="width: 24.844vw;position: absolute;top: 5.375vw;left: 36.979vw;"
        >
            <img
                src="images/estimate_gallery/benefits.png"
                alt=""
                width="100%"
            />
        </div>
        <div style="position: absolute;left: 28vw;top: 9.2vw;width: 8vw;">
            <img src="images/estimate_gallery/0.1.svg" alt="" width="100%" />
        </div>
        <p
            style="
            font-weight: 400;
            color: rgba(0, 0, 0, 1); position: absolute; font-size:1.042vw;left: 13.542vw;top: 8.021vw;"
        >
            We have your results in up <br /> to 48 hours
        </p>
        <div style="position: absolute;left: 31.5vw;top: 16.5vw;width: 4vw;">
            <img src="images/estimate_gallery/0.2.svg" alt="" width="100%" />
        </div>
        <p
            style=" 
            font-weight: 400;
            color: rgba(0, 0, 0, 1); position: absolute; font-size:1.042vw;left: 13.542vw;top: 15.365vw;"
        >
            There is no additional cost
        </p>
        <div style="  position: absolute;left: 28vw;top: 25.6vw;width: 8vw;">
            <img src="images/estimate_gallery/0.3.svg" alt="" width="100%" />
        </div>
        <p
            style=" 
            font-weight: 400;
            color: rgba(0, 0, 0, 1); position: absolute; font-size:1.042vw;left: 13.542vw;top: 24.531vw;"
        >
            Estimates are guaranteed <br /> to be accurate
        </p>
        <div style=" position: absolute;left: 63vw;top: 13.4vw;width: 5vw;">
            <img src="images/estimate_gallery/0.4.svg" alt="" width="100%" />
        </div>
        <p
            style="
            font-weight: 400;
            color: rgba(0, 0, 0, 1); position: absolute; font-size:1.042vw;left: 69.323vw;top: 12.240vw;"
        >
            We provide help by telephonic <br /> consultancy
        </p>
        <div style="position: absolute;left: 63vw;top: 20.7vw;width: 4vw;">
            <img src="images/estimate_gallery/0.5.svg" alt="" width="100%" />
        </div>
        <p
            style="
            font-weight: 400;
            color: rgba(0, 0, 0, 1); position: absolute; font-size:1.042vw;left: 68.281vw;top: 19.635vw;"
        >
            Our reports are easy to <br /> understand
        </p>
        <div style="position: absolute;left: 63vw;top: 29.9vw;width: 3vw;">
            <img src="images/estimate_gallery/0.6.svg" alt="" width="100%" />
        </div>
        <p
            style="
            font-weight: 400;
            color: rgba(0, 0, 0, 1); position: absolute; font-size:1.042vw;left: 67.240vw;top: 28.802vw;"
        >
            Team of experienced estimates is <br /> at your disposal
        </p>
    </div>
    <div style="position:relative;">
        <div style="width: 36.927vw;margin-top: 43.563vw;margin-left:23.750vw;">
            <img src="images/drafting/dots_lines1.svg" alt="" width="100%" />
        </div>
        <div style="margin-top: -3.8vw; margin-left: 24.146vw;">
            <h1 style="font-size: 2.083vw; text-transform: uppercase;">
                HOW DO I GET A PROJECT ESTIMATED?
            </h1>
        </div>
    </div>
    <div style="background-color: #F9F6EF; height:33.063vw; margin-top:5vw;">
        <div style="    margin-left: 30.521vw; padding-top: 1vw;">
            {#each text as data}
                <p style="font-weight: 600;font-size: 1.042vw;">
                    {data.heading}
                </p>
                <p style="font-size: 1.042vw;">{@html data.info}</p>
            {/each}
        </div>
        <div style="margin-top: 2.5vw;margin-left: 30.521vw; cursor: pointer">
            <div
                class="submit-a-quote"
                on:click={() => {
                    displayPopUp();
                }}
            >
                <h5 style="font-weight:500; color:#F36532; margin: 0;">
                    Get a Quote
                </h5>
                <div class="submit-a-quote-arrow">
                    <img src="/images/estimate_gallery/arrow.svg" alt="" />
                </div>
            </div>
        </div>
    </div>
</div>
<div class="mobile">
    <MobileView />
</div>
<Footer />

<style>
    ul li::marker {
        color: #ff6d24;
        font-size: 1.58vw;
    }
    .submit-a-quote {
        width: 10.813vw;
        height: 1.25vw;
        display: flex;
        align-items: baseline;
    }
    .submit-a-quote-arrow {
        width: 1.063vw;
        height: 0.591vw;
        align-items: center;
        margin-left: 0.5vw;
    }
    .submit-a-quote-arrow img {
        width: 100%;
        height: 100%;
    }
    .desktop {
        display: block;
    }
    .mobile {
        display: none;
    }
    @media screen and (max-width: 1024px) {
        .desktop {
            display: none;
        }

        .mobile {
            display: flex;
            justify-content: center;
        }
    }
</style>
